module.exports = __webpack_public_path__ + "img/anohina.0ffcdb06.jpg";